import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SERVER_BASE || "";

// Create socket instance
export const socket = io(SOCKET_URL, {
  autoConnect: false, // prevents auto connection, you can control it manually
  reconnectionAttempts: 5, // try reconnecting 5 times if disconnected
  transports: ["websocket"], // force websocket transport
  auth: (cb) => {
    // Get token from localStorage
    const token = localStorage.getItem("token");
    cb({ token });
  },
});

// Helper function to connect
export const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

// Helper function to disconnect
export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

// Helper function to join a room
export const joinRoom = (room) => {
  socket.emit("join-room", room);
};

// Helper function to leave a room
export const leaveRoom = (room) => {
  socket.emit("leave-room", room);
};

// Deployment event listeners
export const onDeploymentStarted = (callback) => {
  socket.on("deployment_started", callback);
};

export const onDeploymentProgress = (callback) => {
  socket.on("git_deployment_progress", callback);
};

export const onDeploymentCompleted = (callback) => {
  socket.on("deployment_completed", callback);
};

export const onDeploymentFailed = (callback) => {
  socket.on("deployment_failed", callback);
};

export const onDeploymentError = (callback) => {
  socket.on("deployment_error", callback);
};

export const onDeploymentCancelled = (callback) => {
  socket.on("deployment_cancelled", callback);
};

// Remove event listeners
export const offDeploymentStarted = (callback) => {
  socket.off("deployment_started", callback);
};

export const offDeploymentProgress = (callback) => {
  socket.off("git_deployment_progress", callback);
};

export const offDeploymentCompleted = (callback) => {
  socket.off("deployment_completed", callback);
};

export const offDeploymentFailed = (callback) => {
  socket.off("deployment_failed", callback);
};

export const offDeploymentError = (callback) => {
  socket.off("deployment_error", callback);
};

export const offDeploymentCancelled = (callback) => {
  socket.off("deployment_cancelled", callback);
};

// External migration event listeners
export const onExternalMigrationProgress = (callback) => {
  socket.on("externalMigrationProgress", callback);
};

export const onMigrationProgress = (callback) => {
  socket.on("migration_progress", callback);
};

export const offExternalMigrationProgress = (callback) => {
  socket.off("externalMigrationProgress", callback);
};

export const offMigrationProgress = (callback) => {
  socket.off("migration_progress", callback);
};
